module.exports = __webpack_public_path__ + "assets/img/33-s.39cddff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/33-s.jpg
// module id = PVdI
// module chunks = 0